export const SEO = {
  KEYWORDS: [
    `blog`,
    `gatsby`,
    `javascript`,
    `react`,
    `frontend`,
    `beginner`,
    `junior`,
    `junior frontender`
  ]
};
